// @ts-nocheck
import componentsReducer, {
    FoundationComponentsActions,
} from "@store/Framework/Store/Foundation/Components/ComponentsReducer";
import "@toolkit/Framework/Store";
import { combineReducers } from "redux";

const foundationReducers = {
    components: componentsReducer,
};

export type FoundationActions = FoundationComponentsActions;
export default combineReducers(foundationReducers);
